export enum QualificationStandardEnum {
    BRANCHE = "branche",
    PLUS = "plus",
}
